module.exports = __webpack_public_path__ + "img/emo_35.7873504c.gif";